module.exports = __webpack_public_path__ + "img/desc3.eacd77d1.jpg";